export const DoctorLicencePlanType = {
  BASIC: "BASIC",
  STANDARD: "STANDARD",
  PREMIUM: "PREMIUM",
} as const;
export type DoctorLicencePlanType =
  (typeof DoctorLicencePlanType)[keyof typeof DoctorLicencePlanType];

export const LicenceStatus = {
  ACTIVE: "ACTIVE",
  PAUSED: "PAUSED",
  EXPIRED: "EXPIRED",
  CANCELLED: "CANCELLED",
  PENDING_PAYMENT: "PENDING_PAYMENT",
  TRIAL: "TRIAL",
} as const;
export type LicenceStatus = (typeof LicenceStatus)[keyof typeof LicenceStatus];

export const FacilityContractDuration = {
  ONE_YEAR: "ONE_YEAR",
  THREE_YEARS: "THREE_YEARS",
  FIVE_YEARS: "FIVE_YEARS",
} as const;
export type FacilityContractDuration =
  (typeof FacilityContractDuration)[keyof typeof FacilityContractDuration];

export const DoctorContractDuration = {
  MONTHLY: "MONTHLY",
  ANNUALLY: "ANNUALLY",
} as const;
export type DoctorContractDuration =
  (typeof DoctorContractDuration)[keyof typeof DoctorContractDuration];

export const InvitationStatus = {
  PENDING: "PENDING",
  ACCEPTED: "ACCEPTED",
  EXPIRED: "EXPIRED",
} as const;
export type InvitationStatus =
  (typeof InvitationStatus)[keyof typeof InvitationStatus];

export const StaticDoctorProfileStatus = {
  ACTIVE: "ACTIVE",
  INVITED: "INVITED",
  REPLACED: "REPLACED",
  ARCHIVED: "ARCHIVED",
} as const;
export type StaticDoctorProfileStatus =
  (typeof StaticDoctorProfileStatus)[keyof typeof StaticDoctorProfileStatus];

export const DoctorLicenceRequestStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
} as const;
export type DoctorLicenceRequestStatus =
  (typeof DoctorLicenceRequestStatus)[keyof typeof DoctorLicenceRequestStatus];
